import React from 'react';
import { Router, browserHistory } from 'react-router'
import Trigger from './trigger'
import Filter from './filters'
export default class container extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            SelectElements: [],
            element: {},
            funciones: [1],
            operador: "unique",
            listFx: []
        }
        this.AddFunction = this.AddFunction.bind(this);
        this.callBack = this.callBack.bind(this);
        this.setFunction = this.setFunction.bind(this);
        this.diccionario = this.diccionario.bind(this);
        this.renderOperador = this.renderOperador.bind(this);
        this.renderTrigger = this.renderTrigger.bind(this);
        this.callBackFilter = this.callBackFilter.bind(this);
        this.setFilter = this.setFilter.bind(this);
    }

    AddFunction(arr) {
        this.setState({ funciones: arr })
    }

    callBack(obj, key) {
        var array = this.state.listFx;
        var prueba = { prueba: { [key]: obj } }
        array.push(Object.values(prueba)[0]);
        this.setState({ listFx: array });
    }

    callBackFilter(obj, key) {
        var array = this.state.listFx;
        var prueba = obj;
        array.push(prueba);
        this.setState({ listFx: array });
    }


    setFunction() {
        var prueba = {};
        var arrElem = [];
        var key;
        var operador = this.state.operador
        this.state.listFx.map((e, index) => {
            key = Object.keys(e);
            arrElem.push(key);
            prueba[key] = Object.values(e)[0];
        })
        var fx = {
            [this.state.action]: {
                [this.state.operador]: [prueba][0]
            }
        }
        this.props.callBack(fx, arrElem);
    }

    setFilter() {
        var prueba = {};
        var arrElem = [];
        var key;
        var operador = this.state.operador
        this.state.listFx.map((e, index) => {
            var i = Object.keys(e)
            key = Object.values(e);
            if (Object.keys(key[0])[0] !== "value") {
                arrElem.push(Object.keys(key[0]));
            }
            prueba[i] = Object.values(e)[0];
        })
        var fx = {
            [this.state.action]: {
                [this.state.operador]: [prueba][0]
            }
        }
        this.props.callBack(fx, arrElem);
    }

    diccionario(value) {
        switch (value) {
            case "and":
                return (<option value="and" hidden>Se deben cumplir todas las condiciones</option>);
                break;
            case "or":
                return (<option value="or" hidden>Al menos se debe cumplir una condicion</option>);
                break;
            case "unique":
                return (<option value="unique" hidden>Función única</option>);
                break;
            default:
                break;
        }
    }

    renderOperador() {
        var arr = this.state.funciones;
        var count = this.state.funciones.length + 1;
        if (this.state.operador !== "unique") {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group row">
                            <div className="col-md-6">
                                <label htmlFor="name">Tipo de función:</label>
                                <select className="form-control" onChange={(e) => { this.setState({ operador: e.target.value }) }} >
                                    {this.state.operador ? this.diccionario(this.state.operador) : "Seleccione"}
                                    <option value="unique">Función única</option>
                                    <option value="and">Se deben cumplir todas las condiciones</option>
                                    <option value="or">Al menos se debe cumplir una condicion </option>
                                </select>
                            </div>
                            <div className="col-md-6">
                                <button style={{ marginTop: "28px" }} onClick={() => { arr.push(count); this.AddFunction(arr) }} type="button" className="btn btn-outline-primary">Añadir mas condiciones</button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="col-md-12">
                    <div className="form-group row">
                        <label htmlFor="name">Tipo de función:</label>
                        <select className="form-control" onChange={(e) => { this.setState({ operador: e.target.value }) }} >
                            {this.state.operador ? this.diccionario(this.state.operador) : "Seleccione"}
                            <option value="unique">Función única</option>
                            <option value="and">Se deben cumplir todas las condiciones</option>
                            <option value="or">Al menos se debe cumplir una condicion </option>
                        </select>
                    </div>
                </div>
            )
        }
    }

    renderTrigger() {
        switch (this.state.action) {
            case "filter":
                return (
                    this.state.funciones.map((i, index) => (
                        <div>
                            <Filter elements={this.props.elements} data={this.props.pages} element={this.props.element} callBack={this.callBackFilter} />
                        </div>
                    ))
                )
                break;
            case "show":
                return (
                    this.state.funciones.map((i, index) => (
                        <div key={index} >
                            <Trigger elements={this.props.elements} element={this.props.element} callBack={this.callBack} />
                        </div>
                    ))
                )
                break;
            default:
                break;
        }
    }

    render() {
        let arr = this.state.funciones;
        var conditions = <Trigger elements={this.props.elements} element={this.props.element} />;
        let count = 0;

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label htmlFor="name">Acción:</label>
                        <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ action: e.target.value }) }}>
                            <option value="" defaultValue hidden>Seleccione una opción</option>
                            <option value="show">Mostrar</option>
                        </select>
                        <br />
                        {
                            this.renderOperador()
                        }
                    </div>
                    <div className="form-group">
                        {
                            this.state.action ?
                                this.renderTrigger()
                                :
                                ""
                        }
                    </div>
                    <button onClick={() => { this.state.action === "filter" ? this.setFilter() : this.setFunction() }} type="button" className="btn btn-outline-success">Guardar</button>
                </div>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./src/views/functions/container.js